import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=b188cee2&"
import script from "./dialog.js?vue&type=script&lang=js&"
export * from "./dialog.js?vue&type=script&lang=js&"
import style0 from "./dialog.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports